export const links = {
  whatsapp: `https://api.whatsapp.com/send?phone=+639334203621&amp;text=Hello Clubbable!`,
};
